import React, { useEffect, useState } from "react";
//import { Viewer, Worker } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import { useRecoilState } from "recoil";
import { isAddState, isLoadingState } from "./InvoiceCapture/atoms/atoms";

const PDFViewer = ({ pdfUrl }) => {
  const [isLoading, setIsLoading] = useRecoilState(isLoadingState);
  const [isAdd, setIsAdd] = useRecoilState(isAddState);

  const newPlugin = defaultLayoutPlugin({
    //sidebarTabs: (defaultTabs) => [],
    //toolbarPlugin: (defaultTabs) => [],
  });

  return (
    <>
      <div>
        <object
          data={pdfUrl}
          type="application/pdf"
          width="100%"
          height="800px"
        ></object>
        {/* <Worker workerUrl="https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.4.120/pdf.worker.js"> */}
        {/* <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js"> */}
        {/* <Worker
          workerUrl={new URL(
            "pdfjs-dist/build/pdf.worker.min.js",
            import.meta.url
          ).toString()}
        > */}
        {/* {pdfUrl && (
            <>
              <Viewer
                fileUrl={pdfUrl}
                initialPage={1}
                plugins={[newPlugin]}
                defaultScale={0.8}
              />
            </>
          )} */}
        {/* {!pdfUrl && <>No PDF</>} */}
        {/* </Worker> */}
      </div>
    </>
  );
};

export default PDFViewer;
